import { forwardRef, useImperativeHandle } from "react";
import { View } from "react-native";

import type {
  VideoSurfaceContentFit,
  VideoSurfaceHandle
} from "@/playback/players/VideoSurface.web";

export const AirPlayVideoPresentation = forwardRef<
  VideoSurfaceHandle,
  {
    concealed?: boolean;
    contentFit?: VideoSurfaceContentFit;
    onPictureInPictureChange?: (active: boolean) => void;
  }
>(function AirPlayVideoPresentation(_props, ref) {
  useImperativeHandle(ref, () => ({
    availableAudioTracks: [],
    currentTime: 0,
    diagnostics: { active: null, standby: null },
    selectedAudioTrack: null,
    advanceToNext: async () => false,
    advanceToPrevious: async () => false,
    beginScrubbing: () => {},
    endScrubbing: () => {},
    pausePlayback: () => {},
    prepareForSourceChange: async () => {},
    playAfterScrubbing: () => {},
    requestPictureInPicture: () => Promise.resolve(),
    resumePlayback: () => {},
    setAudioTrack: () => {},
    setPlaybackRate: () => {},
    terminatePlayback: () => {},
    seek: () => {}
  }));
  return <View />;
});
